const country = {
    AF: "阿富汗",
    AL: "阿爾巴尼亞",
    DZ: "阿爾及利亞",
    AS: "美屬薩摩亞",
    AD: "安道爾",
    AO: "安哥拉",
    AG: "安提瓜和巴布達",
    AR: "阿根廷",
    AM: "亞美尼亞",
    AU: "澳洲",
    AT: "奧地利",
    AZ: "阿塞拜疆",
    BS: "巴哈馬",
    BH: "巴林",
    BD: "孟加拉",
    BB: "巴貝多",
    BY: "白俄羅斯",
    BE: "比利時",
    BZ: "伯利茲",
    BJ: "貝南",
    BT: "不丹",
    BO: "玻利維亞",
    BA: "波士尼亞與赫塞哥維納",
    BW: "波札那",
    BR: "巴西",
    BN: "汶萊",
    BG: "保加利亞",
    BF: "布吉納法索",
    BI: "布隆迪",
    KH: "柬埔寨",
    CM: "喀麥隆",
    CA: "加拿大",
    CV: "佛得角",
    CF: "中非共和國",
    TD: "乍得",
    CL: "智利",
    CN: "中國",
    CO: "哥倫比亞",
    KM: "科摩羅",
    CG: "剛果（布）",
    CD: "剛果（金）",
    CR: "哥斯大黎加",
    CI: "科特迪瓦",
    HR: "克羅埃西亞",
    CU: "古巴",
    CY: "塞浦路斯",
    CZ: "捷克",
    DK: "丹麥",
    DJ: "吉布地",
    DM: "多明尼克",
    DO: "多明尼加共和國",
    EC: "厄瓜多",
    EG: "埃及",
    SV: "薩爾瓦多",
    GQ: "赤道幾內亞",
    ER: "厄立特里亞",
    EE: "愛沙尼亞",
    ET: "埃塞俄比亞",
    FJ: "斐濟",
    FI: "芬蘭",
    FR: "法國",
    GA: "加彭",
    GM: "岡比亞",
    GE: "格魯吉亞",
    DE: "德國",
    GH: "加納",
    GR: "希臘",
    GD: "格林納達",
    GT: "瓜地馬拉",
    GN: "幾內亞",
    GW: "幾內亞比索",
    GY: "圭亞那",
    HT: "海地",
    HN: "宏都拉斯",
    HU: "匈牙利",
    IS: "冰島",
    IN: "印度",
    ID: "印尼",
    IR: "伊朗",
    IQ: "伊拉克",
    IE: "愛爾蘭",
    IL: "以色列",
    IT: "義大利",
    JM: "牙買加",
    JP: "日本",
    JO: "約旦",
    KZ: "哈薩克",
    KE: "肯亞",
    KI: "吉里巴斯",
    KP: "朝鮮",
    KR: "韓國",
    KW: "科威特",
    KG: "吉爾吉斯斯坦",
    LA: "寮國",
    LV: "拉脫維亞",
    LB: "黎巴嫩",
    LS: "萊索托",
    LR: "利比里亞",
    LY: "利比亞",
    LI: "列支敦士登",
    LT: "立陶宛",
    LU: "盧森堡",
    MG: "馬達加斯加",
    MW: "馬拉威",
    MY: "馬來西亞",
    MV: "馬爾地夫",
    ML: "馬裡",
    MT: "馬爾他",
    MH: "馬紹爾群島",
    MR: "茅利塔尼亞",
    MU: "毛里求斯",
    MX: "墨西哥",
    MD: "摩爾多瓦",
    MC: "摩納哥",
    MN: "蒙古",
    ME: "黑山",
    MA: "摩洛哥",
    MZ: "莫三比克",
    MM: "緬甸",
    NA: "納米比亞",
    NR: "諾魯",
    NP: "尼泊爾",
    NL: "荷蘭",
    NZ: "紐西蘭",
    NI: "尼加拉瓜",
    NE: "尼日",
    NG: "尼日利亞",
    NO: "挪威",
    OM: "阿曼",
    PK: "巴基斯坦",
    PW: "帛琉",
    PA: "巴拿馬",
    PG: "巴布亞紐幾內亞",
    PY: "巴拉圭",
    PE: "秘魯",
    PH: "菲律賓",
    PL: "波蘭",
    PT: "葡萄牙",
    QA: "卡達",
    RO: "羅馬尼亞",
    RU: "俄羅斯",
    RW: "盧安達",
    KN: "聖克里斯多福及尼維斯",
    LC: "聖露西亞",
    VC: "聖文森及格瑞那丁",
    WS: "薩摩亞",
    SM: "聖馬利諾",
    ST: "聖多美和普林西比",
    SA: "沙烏地阿拉伯",
    SN: "塞內加爾",
    RS: "塞爾維亞",
    SC: "塞席爾",
    SL: "塞拉利昂",
    SG: "新加坡",
    SK: "斯洛伐克",
    SI: "斯洛維尼亞",
    SB: "所羅門群島",
    SO: "索馬利亞",
    ZA: "南非",
    ES: "西班牙",
    LK: "斯里蘭卡",
    SD: "蘇丹",
    SR: "蘇利南",
    SZ: "史瓦濟蘭",
    SE: "瑞典",
    CH: "瑞士",
    SY: "敘利亞",
    TW: "台灣",
    TJ: "塔吉克斯坦",
    TZ: "坦尚尼亞",
    TH: "泰國",
    TL: "東帝汶",
    TG: "多哥",
    TO: "東加",
    TT: "特立尼達和多巴哥",
    TN: "突尼斯",
    TR: "土耳其",
    TM: "土庫曼斯坦",
    TV: "吐瓦魯",
    UG: "烏幹達",
    UA: "烏克蘭",
    AE: "阿聯酋",
    GB: "英國",
    US: "美國",
    UY: "烏拉圭",
    UZ: "烏茲別克",
    VU: "瓦努阿圖",
    VE: "委內瑞拉",
    VN: "越南",
    YE: "也門",
    ZM: "尚比亞",
    ZW: "辛巴威",
    FM: "斐濟"
};

export default country;